(() => {
  const STORAGE_KEY = 'facet_open_state_v2';

  function ns() {
    return location.pathname;
  }

  function read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch {
      return {};
    }
  }

  function write(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {}
  }

  function getFacetRoot() {
    return (
      document.querySelector('.facets') ||
      document.querySelector('.facet-filters') ||
      document.querySelector('#FacetFiltersForm') ||
      document.querySelector('form[action*="/collections/"]')
    );
  }

  function getDetailsList() {
    return document.querySelectorAll(
      '.facets details, .facet-filters details, details.facets__disclosure, details.disclosure-has-popup'
    );
  }

  function keyOf(details) {
    if (details.id) return details.id;

    const summary = details.querySelector('summary');
    const label = summary ? summary.textContent.trim().replace(/\s+/g, ' ') : '';

    const siblings = [...(details.parentElement?.querySelectorAll('details') || [])];
    const idx = siblings.indexOf(details);

    return `details:${label || 'unknown'}:${idx}`;
  }

  function setRemember(details, isOpen) {
    const data = read();
    const page = ns();
    data[page] = data[page] || {};
    const k = keyOf(details);

    if (isOpen) data[page][k] = true;
    else delete data[page][k];

    write(data);
  }

  // 让某个 facets 展开：优先用 open；不行就点 summary（兼容主题）
  function forceOpen(details) {
    details.setAttribute('open', '');

    // 有些主题不会因 open 而展开动画/内容，所以再补一次“点击展开”
    const summary = details.querySelector('summary');
    if (summary && !details.open) {
      summary.click();
    } else if (summary && details.open) {
      // 有些主题用自定义状态，不认 details.open，但 click 会生效
      // 这里做一次保险：如果内容仍是收起状态，click 再开一次
      // （不做复杂判断，避免误关）
    }
  }

  function forceClose(details) {
    details.removeAttribute('open');

    const summary = details.querySelector('summary');
    // 不强制 click 关闭，避免主题逻辑反复抖动
  }

  // 进入页面：全部合上（除非记忆里要开）
  function applyState() {
    const data = read();
    const openMap = (data[ns()] || {});

    getDetailsList().forEach((d) => {
      const shouldOpen = !!openMap[keyOf(d)];
      if (shouldOpen) forceOpen(d);
      else forceClose(d);
    });
  }

  // 1) 捕捉用户“手动打开/关闭”的最稳方式：监听 toggle（details 自带事件）
  function bindToggleRemember() {
    document.addEventListener(
      'toggle',
      (e) => {
        const details = e.target;
        if (!(details instanceof HTMLDetailsElement)) return;
        if (!details.closest('.facets, .facet-filters, form[action*="/collections/"]')) return;

        setRemember(details, details.open);
      },
      true // 捕获阶段，避免被主题 stopPropagation
    );
  }

  // 2) 用户勾选筛选后：主题会 AJAX 重绘 facets，重绘后再 apply
  function bindReapplyOnUpdates() {
    // change 保险
    document.addEventListener('change', (e) => {
      if (!e.target.closest('.facets, .facet-filters, form[action*="/collections/"]')) return;
      setTimeout(applyState, 30);
      setTimeout(applyState, 180);
      setTimeout(applyState, 450);
    });

    // DOM 重绘监听
    const obs = new MutationObserver(() => {
      applyState();
    });

    const start = () => {
      const root = getFacetRoot();
      if (root) {
        obs.observe(root, { childList: true, subtree: true });
        applyState();
      } else {
        setTimeout(start, 300);
      }
    };

    start();
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindToggleRemember();
    bindReapplyOnUpdates();
    applyState();
  });
})();
